import { CloseIcon } from '@chakra-ui/icons'
import { Box, Button, Divider, Flex, Text } from '@chakra-ui/react'
import { OrderProductForm } from 'domain/purchase/forms'
import React from 'react'
import { useSetRecoilState } from 'recoil'
import { orderProductFormsState } from 'state/purchase/atoms'
import { MoneyText } from 'views/component/MoneyText'

type OrderItemProps = {
  orderProductForm: OrderProductForm
}

export const OrderItem = ({
  orderProductForm: { productId, productName, count, price, unit },
}: OrderItemProps) => {
  const setOrderProductForms = useSetRecoilState(orderProductFormsState)

  const onClickDelete = () => {
    setOrderProductForms((prev) =>
      prev.filter((form) => form.productId !== productId),
    )
  }

  return (
    <Flex mt={4}>
      <Box ml={4} flex={1}>
        <Flex justifyContent={'space-between'} alignItems={'center'} mb={8}>
          <Text>{`${productName}`}</Text>
          <Button onClick={onClickDelete} variant={'link'} fontSize={'lg'}>
            <CloseIcon />
          </Button>
        </Flex>
        <Flex>
          <MoneyText amount={price} unit={'₩'} textProps={{ mb: 4 }} />
          <Text ml={2}>{`/  ${count} ширхэг`}</Text> {/*수량*/}
        </Flex>
        <Divider />
      </Box>
    </Flex>
  )
}
